import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../../../../../modules/infra/i18n';
import SaveButton from '../../../../../common/buttons/saveButton';
import shopifyIcon from '../../../../../../../images/shopifyIcon.png';

import PendingConnectionModal from '../../../../../common/PendingConnectionModal';
import ShopifyUrlField from './ShopifyUrlField';

const ConnectToShopify = ({ handleSubmit, invalid, openedIsOn }) => (
  <div className="connect-to-shopify">
    <img alt="shopify-logo" className="shopify-logo" src={shopifyIcon} role="presentation" />
    <form onSubmit={handleSubmit}>
      <h1>Shopify</h1>
      <h2>{t('settings:integrations.shopify.connect_description')}</h2>
      <ShopifyUrlField />
      <div className="connect-to-shopify__footer">
        <SaveButton content={t('settings:integrations.shopify.connect_button')} disabled={invalid} />
      </div>
    </form>
    <PendingConnectionModal
      display-if={openedIsOn}
      text={t('settings:integrations.shopify.pending_integration_message')}
    />
  </div>
);

ConnectToShopify.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  openedIsOn: PropTypes.bool.isRequired,
};

export default ConnectToShopify;
